module.exports = __webpack_public_path__ + "img/waistband button diameter.c290e850.png";